import React from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { SidebarProvider, SidebarTrigger, SidebarInset } from '@repo/ui/Sidebar';
import { Separator } from '@repo/ui/Separator';
import { UserContext } from '@repo/ui/UserContext';
import { AccountContext } from '@/components/AccountContext';
import { AnnouncementBanner } from '@/components/AnnouncementBanner';
import { AppBreadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';

interface MainLayoutProps {
  children?: React.ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <UserContext>
      <AccountContext>
        <div className="flex relative flex-col w-full h-full bg-grey-300 dark:bg-blue-1100">
          <AnnouncementBanner />
          <SidebarProvider>
            <Navbar />
            <Sidebar />
            <SidebarInset>
              <div className="relative w-full h-full dark:bg-blue-1100 bg-grey-300">
                <header className="hidden md:flex h-10 shrink-0 items-center gap-2 relative top-20 px-4 z-30">
                  <SidebarTrigger />
                  <Separator orientation="vertical" className="mr-2 !h-4" />
                  <AppBreadcrumbs />
                </header>
                <div className="overflow-x-scroll relative w-full no-scrollbar">
                  {children}
                </div>
              </div>
            </SidebarInset>
          </SidebarProvider>
        </div>
      </AccountContext>
    </UserContext>
  );
};
